import { useSelector } from "react-redux";
import { selectFinanceConfiguration } from "../../../../../ducks/data/finance/selectors";
import AddEditEconomicCustomerDialog from "./AddEditEconomicCustomerDialog";
import AddEditTripletexCustomerDialog from "./AddEditTripletexCustomerDialog";
import AddEditBusinessCentralCustomerDialog from "./AddEditBusinessCentralCustomerDialog";
import AddEditPowerOfficeCustomerDialog from "./AddEditPowerOfficeCustomerDialog";

const AddEditCustomerDialog = ({
  id,
  onClose,
}: {
  id: "NEW" | string;
  onClose: () => void;
}) => {
  const financeConfig = useSelector(selectFinanceConfiguration);

  return (
    <>
      {financeConfig === "E-CONOMIC" && (
        <AddEditEconomicCustomerDialog
          id={id === "NEW" ? null : id}
          onClose={onClose}
        />
      )}
      {financeConfig === "Tripletex" && (
        <AddEditTripletexCustomerDialog
          id={id === "NEW" ? null : id}
          onClose={onClose}
        />
      )}
      {financeConfig === "Business Central" && (
        <AddEditBusinessCentralCustomerDialog
          id={id === "NEW" ? null : id}
          onClose={onClose}
        />
      )}
      {financeConfig === "PowerOffice" && (
        <AddEditPowerOfficeCustomerDialog
          id={id === "NEW" ? null : id}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default AddEditCustomerDialog;
